import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const styles = require("./StatusBarButton.scss");

interface StatusBarButtonProps {
    readonly children: string;
    readonly className?: string;
    readonly disabled?: boolean;
    readonly onClick?: () => void;
}

export default function StatusBarButton({
    children,
    disabled,
    onClick,
    className
}: StatusBarButtonProps) {
    return (
        <button
            className={classnames(styles.button, className)}
            onClick={onClick}
            disabled={disabled === true}
        >
            <span>{children}</span>
        </button>
    );
}
